import { AdminUniversalSearchResultKind } from "@/__generated__/graphql";

export const UNIVERSAL_SEARCH_KIND_HEADING: Record<
  AdminUniversalSearchResultKind,
  string
> = {
  [AdminUniversalSearchResultKind.Workspace]: "Workspace",
  [AdminUniversalSearchResultKind.TaxReturn]: "Returns",
};

const KIND_GROUP_PRIORITY: Record<AdminUniversalSearchResultKind, number> = {
  [AdminUniversalSearchResultKind.Workspace]: 0,
  [AdminUniversalSearchResultKind.TaxReturn]: 1,
};

export function groupUniversalSearchResultsByKind<
  T extends { kind: AdminUniversalSearchResultKind; subtitle?: string | null },
>(results: T[]): { kind: AdminUniversalSearchResultKind; results: T[] }[] {
  const groups: { kind: AdminUniversalSearchResultKind; results: T[] }[] = [];
  const indexByKind = new Map<AdminUniversalSearchResultKind, number>();
  for (const result of results) {
    const index = indexByKind.get(result.kind);
    if (index === undefined) {
      indexByKind.set(result.kind, groups.length);
      groups.push({ kind: result.kind, results: [result] });
    } else {
      groups[index].results.push(result);
    }
  }

  return groups
    .map((group) =>
      group.kind === AdminUniversalSearchResultKind.TaxReturn
        ? { ...group, results: sortTaxReturnsByYearDesc(group.results) }
        : group,
    )
    .sort((left, right) => {
      const leftPriority = KIND_GROUP_PRIORITY[left.kind];
      const rightPriority = KIND_GROUP_PRIORITY[right.kind];
      if (leftPriority !== rightPriority) {
        return leftPriority - rightPriority;
      }
      return UNIVERSAL_SEARCH_KIND_HEADING[left.kind].localeCompare(
        UNIVERSAL_SEARCH_KIND_HEADING[right.kind],
      );
    });
}

// The subtitle is the tax year.
// We can make this nicer in the future by returning an actual union type
// and providing the whole return object here instead of interpreting the subtitle.
function sortTaxReturnsByYearDesc<T extends { subtitle?: string | null }>(
  results: T[],
): T[] {
  return [...results].sort(
    (left, right) => Number(right.subtitle ?? 0) - Number(left.subtitle ?? 0),
  );
}
